export default __webpack_public_path__ + "static/media/icon_dots.4b755919.svg";